module.exports = require("discourse/lib/object");